import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

/**
 * Skeleton for the Scheduling page data area.
 * Shows: Calendar card with toolbar + grid cells.
 * PageHeader stays visible — only the data area shows skeleton (like WorkList/Studies pattern).
 */
const SchedulingSkeleton: React.FC = () => (
    <div className="animate-fade-in-up">
        {/* Calendar card */}
        <div
            className="rounded-xl border overflow-hidden"
            style={{
                background: 'var(--v2-bg-card)',
                borderColor: 'var(--v2-border-card)',
                boxShadow: 'var(--v2-shadow-card)',
            }}
        >
            {/* Calendar toolbar */}
            <div
                className="flex items-center justify-between px-5 py-3 border-b"
                style={{ borderColor: 'var(--v2-border-subtle)', background: 'var(--v2-bg-surface)' }}
            >
                <div className="flex items-center gap-2">
                    <ShimmerBox className="h-8 w-8 rounded-lg" delay="0s" />
                    <ShimmerBox className="h-8 w-8 rounded-lg" delay="0.05s" />
                    <ShimmerBox className="h-6 w-36 rounded-md ml-2" delay="0.1s" />
                </div>
                <div className="flex items-center gap-1.5">
                    <ShimmerBox className="h-8 w-16 rounded-lg" delay="0.15s" />
                    <ShimmerBox className="h-8 w-16 rounded-lg" delay="0.2s" />
                    <ShimmerBox className="h-8 w-16 rounded-lg" delay="0.25s" />
                </div>
            </div>

            {/* Calendar day headers */}
            <div
                className="grid grid-cols-7 border-b"
                style={{ borderColor: 'var(--v2-border-subtle)' }}
            >
                {Array.from({ length: 7 }).map((_, i) => (
                    <div key={i} className="flex items-center justify-center py-2">
                        <ShimmerBox className="h-4 w-8 rounded" delay={`${i * 0.03}s`} />
                    </div>
                ))}
            </div>

            {/* Calendar grid (5 weeks × 7 days) */}
            {Array.from({ length: 5 }).map((_, w) => (
                <div
                    key={w}
                    className="grid grid-cols-7 border-b last:border-0"
                    style={{ borderColor: 'var(--v2-border-divider)' }}
                >
                    {Array.from({ length: 7 }).map((_, d) => (
                        <div
                            key={d}
                            className="min-h-[80px] border-r last:border-0 p-2"
                            style={{ borderColor: 'var(--v2-border-divider)' }}
                        >
                            <ShimmerBox className="h-4 w-5 rounded mb-2" delay={`${w * 0.04}s`} />
                            {/* Random event blocks */}
                            {Math.random() > 0.6 && (
                                <ShimmerBox className="h-5 w-full rounded mb-1" delay={`${w * 0.04 + 0.1}s`} />
                            )}
                            {Math.random() > 0.8 && (
                                <ShimmerBox className="h-5 w-3/4 rounded" delay={`${w * 0.04 + 0.15}s`} />
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default SchedulingSkeleton;
